import React from 'react'
import Sidebar from '../../Dashboard/StudentDashboard/Sidebar/SideBar';
// import "./StudentAssignment.css";

export default function StudentAssignment() {
  return (
    <div class="container-scroller">
    <div class="container-fluid page-body-wrapper">
        <Sidebar/>
    <div class="main-panel">
          <div class="content-wrapper">
          <div >
          {/* style={{display:'flex',widows:'100%',padding:'25px 25px'}} */}
        <div>
      {/* Topic Progress Section */}
      <section className="progressAssignment-section">
        <ul class="stepper">
          <li class="done">
            <div class="item">
              Topic 1
            </div>
          </li>
          <li class="done">
          <div class="item">
              Topic 2
          </div>
          </li>
          <li class="wip">
          <div class="item">
              Topic 3
          </div>
          </li>
          <li class="ready">
          <div class="item">
              Topic 4
          </div>
          </li>
          <li class="ready">
          <div class="item">
              Topic 5
          </div>
          </li>
          <li class="ready">
          <div class="item">
              Topic 6
          </div>
          </li>
        </ul>
      </section>

      {/* Badges Section */}
      <section className="badges">
        <h2>BADGES</h2>
        <div className="badge-list">
          <span>Quiz Master</span>
          
          <span>Achiever</span>
          <span>Champion</span>
          <span>Legend</span>
        </div>
      </section>

      {/* Assignment Guideline */}
      <section className="guideline">
        <h2 className="guideline-title">ASSIGNMENT GUIDELINE</h2>
      </section>

      {/* Assignment Section */}
      <section className="assignment">
        <h2>ASSIGNMENT SECTION</h2>
        <div className="assignment-content">
          <h3>Question</h3>
          <p>
            Lorem Ipsum is simply dummy text of the printing and typesetting
            industry. Lorem Ipsum has been the industry's standard dummy text
            ever since the 1500s?
          </p>
          <div className="answer">
            <label>Answer</label>
            <textarea placeholder="Enter your answer here"></textarea>
          </div>
        </div>
      </section>
      </div>
    </div>
            </div>
            </div>
            </div>
            </div>
  )
}